import { AsyncPipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'
import { isObservable, map, Observable } from 'rxjs'
import { getCurrencySymbol } from '@angular/common'

/**
 * gbCurrencySymbol pipe that returns the currency
 * symbol for a given currency code
 */

@Pipe({
  name: 'gbCurrencySymbol',
  pure: false,
})
export class GbCurrencySymbolPipe implements PipeTransform {
  constructor(private asyncPipe: AsyncPipe) {}

  transform(currencyCode: string | Observable<string>, symbolFormat: 'wide' | 'narrow' = 'narrow'): any {
    if (isObservable(currencyCode)) {
      return this.asyncPipe.transform(
        currencyCode.pipe(map((currencyCode) => getCurrencySymbol(currencyCode, symbolFormat))),
      )
    }
    return getCurrencySymbol(currencyCode, symbolFormat)
  }
}
